package com.essntl.features.itinerary.ui.edit_itinerary_service

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.rememberFind

@Composable
fun EditItineraryServiceState.rememberCategory(id: String?): CategoryModel? {
    return rememberFind(
        getAllCategory.data.orEmpty(),
        id,
    ) { category -> category.id }
}

@Composable
fun EditItineraryServiceState.rememberSender(
    whapiMessage: WhapiMessageModel,
): ProfileModel? {
    return remember(
        getAllMessages.data.orEmpty(),
        whapiMessage,
    ) {
        val messages = getAllMessages.data
            .orEmpty()
            .mapNotNull { msg ->
                when (msg.type) {
                    is MessageModel.Type.Whatsapp -> msg
                    else -> null
                }
            }

        messages.firstOrNull { it.platformId == whapiMessage.id }?.sender
    }
}